// Phase 2D.2A — these two side-effect imports MUST stay first. The first one
// captures the shape of the landing URL before the Supabase client can strip
// the fragment; the second installs the PASSWORD_RECOVERY listener before the
// client can emit it.
import "@/lib/recoveryLinkParams";
// Phase 2D.2B — same reason: the shape of a signup-confirmation landing URL is
// captured before the Supabase client can consume the fragment.
import "@/lib/signupLinkParams";
// Phase 2D.1C — the Owner invitation token lives in the fragment. It is captured
// and stripped from the address bar HERE, before React mounts, before the
// Supabase client exists and before any API or telemetry code can run.
import "@/lib/inviteToken";
import "@/lib/passwordRecovery";
import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
